import * as React from 'react';

const Wrapper = ({ children }: React.PropsWithChildren<{}>) =>
    <div className="wrapper">
        <div className="container">
            <a href="https://epharma.com.br/" target="_blank" className="visit_site">VISITAR O SITE DA EPHARMA</a>
            <div className="app__wrapper">
                {children}
            </div>
        </div>
    </div>

export default Wrapper;